import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import sidebarActions from '../../redux/sidebar/actions';
import BaseLayout from './BaseLayout';

const mapStateToProps = ({ sidebar, router }) => ({
  ...sidebar,
  router,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      changeLayoutCollapsed: sidebarActions.changeLayoutCollapsed,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(BaseLayout);
